import { c as _c } from "react/compiler-runtime";
import { GoogleCalendarIcon } from '@systemeio/ui/icons';
import { Modal } from '@systemeio/ui';
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration';
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration';
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton';
import { useGoogleIntegrations } from 'modules/profile/integrations/google/hooks/use-google-integrations';
import { useIntegrateGoogle } from 'modules/profile/integrations/google/hooks/use-integrate-google';
import { IntegrationInterface, IntegrationUseCaseEnum } from 'modules/profile/integrations/google/types';
import React from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { GoogleCalendarConfiguration } from './calendar-configuration';
import { getHelpPageLinkGoogleCalendar } from '../utils/get-help-page-link-google-calendar';
export const GoogleCalendarIntegrationComingSoon = () => {
  const $ = _c(8);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <GoogleCalendarIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.user_settings.integrations_page.google_calendar.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.user_settings.integrations_page.google_calendar.subtitle");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <WrapperIntegration icon={t0} title={t1} subTitle={t2} isComingSoon={true} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const GoogleCalendarIntegration = t0 => {
  const $ = _c(34);
  const {
    opened,
    setOpened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    openGoogleLogin,
    openGoogleLoginToReconnect,
    isFetching
  } = useIntegrateGoogle({
    onSuccess: handleIntegrationSuccess
  });
  const {
    revalidateModules
  } = useRevalidateModules();
  const {
    getIntegrationsByUseCase,
    mutateIntegrationsWithNewItem
  } = useGoogleIntegrations();
  const data = getIntegrationsByUseCase(IntegrationUseCaseEnum.Calendar);
  async function handleIntegrationSuccess(item) {
    await mutateIntegrationsWithNewItem(item);
    await revalidateModules([RequestModuleEnum.GoogleIntegrationsCalendars], true);
  }
  let t1;
  if ($[0] !== openGoogleLogin) {
    t1 = async function openLogin() {
      await openGoogleLogin(IntegrationUseCaseEnum.Calendar);
    };
    $[0] = openGoogleLogin;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openLogin = t1;
  let t2;
  if ($[2] !== openGoogleLoginToReconnect) {
    t2 = async function openReconnect(id, preselectedEmail) {
      await openGoogleLoginToReconnect(id, preselectedEmail);
    };
    $[2] = openGoogleLoginToReconnect;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const openReconnect = t2;
  const isConnected = data?.items.some(_temp) ?? false;
  const hasIntegrations = data?.items.length !== 0;
  if (!data) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <WrapperIntegrationSkeleton />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <GoogleCalendarIcon />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.user_settings.integrations_page.google_calendar.name");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("dashboard.user_settings.integrations_page.google_calendar.subtitle");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== setOpened) {
    t6 = () => setOpened(true);
    $[10] = setOpened;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isConnected || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <WrapperIntegration icon={t3} title={t4} subTitle={t5} onClick={t6} isConnect={isConnected} />;
    $[12] = isConnected;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("dashboard.user_settings.integrations_page.google_calendar.title");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== setOpened) {
    t9 = () => setOpened(false);
    $[19] = setOpened;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== hasIntegrations || $[22] !== isFetching || $[23] !== openLogin || $[24] !== openReconnect) {
    t10 = <>{hasIntegrations ? <GoogleCalendarConfiguration onAddAccount={openLogin} onReconnect={openReconnect} /> : <ConnectInfoIntegration isFetching={isFetching} href={getHelpPageLinkGoogleCalendar()} handleOpenIntegrationLogin={openLogin} infoText="dashboard.user_settings.integrations_page.google_calendar_integration.help" />}</>;
    $[21] = hasIntegrations;
    $[22] = isFetching;
    $[23] = openLogin;
    $[24] = openReconnect;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== opened || $[27] !== t10 || $[28] !== t8 || $[29] !== t9) {
    t11 = <Modal title={t8} onClose={t9} opened={opened}>{t10}</Modal>;
    $[26] = opened;
    $[27] = t10;
    $[28] = t8;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t7) {
    t12 = <>{t7}{t11}</>;
    $[31] = t11;
    $[32] = t7;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
function _temp(integration) {
  return !integration.disconnectedAt;
}